import { IWindowsAccumulated } from '@core/market-data-sdk';
import { ChartContext } from '../interface';

interface IWindowsAccumulatedWithColor extends IWindowsAccumulated {
  color: string;
}

export const createMovableWindowsSeries = (
  series: IWindowsAccumulatedWithColor[]
): ChartContext.IChartSeries[] => {
  return series.map((item) => ({
    name: item.nicename,
    id: item.identifier,
    type: 'line',
    color: item.color,
    data: item.data.map(({ d, r }) => [new Date(d).getTime(), r]),
  }));
};
